/* @flow */
import BatchRoleCorrectionModal from './BatchRoleCorrectionModalForGroupMemberships';

export default BatchRoleCorrectionModal;
export { default as BatchRoleCorrectionModalDataContainer } from './BatchRoleCorrectionModalForPeopleListDataContainer';
export { default as BatchRoleCorrectionModalCommon } from './BatchRoleCorrectionModalCommon';
